import { Select } from 'antd';
import { NEWS_TYPE_DICTIONARY, NEWS_TYPE_DICTIONARY_INT } from 'appConstants';
import React from 'react';

const NewsTypeSelect = ({ intValue, ...props }) => {
  return (
    <Select
      options={Object.entries(
        intValue ? NEWS_TYPE_DICTIONARY_INT : NEWS_TYPE_DICTIONARY
      ).map(([key, value]) => ({
        value: key,
        label: value
      }))}
      style={{ width: '100%' }}
      placeholder="Chọn loại"
      allowClear
      {...props}
    />
  );
};

export default NewsTypeSelect;
